import { render, staticRenderFns } from "./FutureImageThumbnail.vue?vue&type=template&id=3b8eb4ab&"
import script from "./FutureImageThumbnail.vue?vue&type=script&lang=ts&"
export * from "./FutureImageThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./FutureImageThumbnail.vue?vue&type=style&index=0&id=3b8eb4ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports